const onLettersPageMatch = () => {
  const waitForPageLoad = setInterval(async () => {
    const pageContent = document.querySelector('#LetterDataSection')
    if (pageContent) {
      clearInterval(waitForPageLoad)

      const { templates } = await getImpowerXData(
        `${baseApiUrl}/api/impowerX/standard-letter-templates`
      )

      const field = generateInputField({
        id: 'standard-letter-template',
        fieldType: 'DropdownMenu',
        name: 'standardLetterTemplate',
        label: 'Vorlage auswählen',
        options: templates.map(template => ({ ...template, label: template.title })),
        columnClass: 'standard-template-column',
        isDisabled: false,
      })

      const col = $('#letterData .sub-section-content .sub-section-content-row')
        .first()
        .find('.sub-section-content-column')
        .last()

      col.append('<div class="SelectInput"></div>')
      col.find('.SelectInput').append(field)

      $('.impowerx-select').on('click', () => {
        $('.impowerx-select-dropdown').removeClass('ant-select-dropdown-hidden')
      })
  
      // hide the dropdown when clicking outside of it
      $(document).on('click', function (event) {
        if ($(event.target).closest('.dropdown-wrapper').length) {
          const selectedOption = event.target.textContent?.trim()

          $(event.target)
            .closest('.dropdown-wrapper')
            .siblings('.ant-select')
            .find('input')
            .val(selectedOption)

          const selectedTemplate = templates.find(template => template.title === selectedOption)

          // get the title input
          const input = document.querySelector('#letterData .sub-section-content .sub-section-content-row .sub-section-content-column input.ant-input.ant-input-status-success.Input')
          // Get the native property descriptor for 'value'
          const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
            window.HTMLInputElement.prototype,
            'value'
          ).set
          // Use it to set the value
          nativeInputValueSetter.call(input, selectedTemplate.title)
          // Dispatch an 'input' event to notify React
          input.dispatchEvent(new Event('input', { bubbles: true }))

          $('#letterData .RichTextEditor .jodit-wysiwyg').first().html(selectedTemplate.description)
        }
  
        if (!$(event.target).closest('.ant-select').length) {
          $('.impowerx-select-dropdown').addClass('ant-select-dropdown-hidden')
        }
      })  
    }
  }, 100)
}
